<section class="availability-panel" [class.fullscreen-panel]="fullscreen" aria-label="Availability overview">
  <header class="panel-header">
    <div>
      <h2>Availability overview</h2>
      <p>Collector availability &amp; assigned events</p>
    </div>
    <div class="panel-actions">
      <button type="button" class="panel-action" (click)="toggleFullscreen()" [attr.aria-pressed]="fullscreen">
        {{ fullscreen ? 'Exit full screen' : 'Full screen' }}
      </button>
      <button type="button" class="close-action" aria-label="Close availability" (click)="requestClose()">×</button>
    </div>
  </header>

  <nav class="view-tabs" aria-label="Availability views">
    <button type="button" [class.active]="activeTab === 'collectors'" (click)="setTab('collectors')">Collectors</button>
    <button type="button" [class.active]="activeTab === 'teams'" (click)="setTab('teams')">Teams</button>
  </nav>

  <div class="overview-controls">
    <label class="search-control">
      <span>Search collector or team</span>
      <input
        type="search"
        [value]="query"
        placeholder="Collector name or team…"
        (input)="onQueryChanged($any($event.target).value)"
      />
    </label>
    <label>
      <span>Date</span>
      <input type="date" [value]="selectedDate" (change)="onDateChanged($any($event.target).value)" />
    </label>
    <label>
      <span>Team</span>
      <select [value]="team" (change)="onTeamChanged($any($event.target).value)">
        <option value="">All teams</option>
        <option *ngFor="let option of teamOptions" [value]="option">{{ option }}</option>
      </select>
    </label>
    <label class="availability-filter-control" *ngIf="activeTab === 'collectors'">
      <span>Show collectors</span>
      <select
        [value]="availabilityFilter"
        (change)="onAvailabilityFilterChanged($any($event.target).value)"
      >
        <option value="availableAtLeastOnce">Partially free</option>
        <option value="freeForEntirePeriod">Fully free</option>
        <option value="notSubmitted">Not submitted</option>
        <option value="all">All collectors</option>
      </select>
    </label>
  </div>

  <app-availability-kpis
    [kpis]="kpis"
    [selectedTeam]="team"
    (teamSelected)="selectKpiTeam($event)"
  ></app-availability-kpis>

  <div class="range-heading">
    <strong>{{ formatMinuteOfDay(fromMinute) }} – {{ formatMinuteOfDay(toMinute) }}</strong>
    <span>{{ dateCaption }}</span>
  </div>
  <mat-slider class="range-slider" [min]="0" [max]="dayMinutes" [step]="sliderStep" [showTickMarks]="true" aria-label="Selected availability period">
    <input matSliderStartThumb [value]="fromMinute" (valueChange)="onFromMinuteChanged($event)" aria-label="Period start" />
    <input matSliderEndThumb [value]="toMinute" (valueChange)="onToMinuteChanged($event)" aria-label="Period end" />
  </mat-slider>
  <div class="slider-labels" aria-hidden="true"><span>00:00</span><span>06:00</span><span>12:00</span><span>18:00</span><span>24:00</span></div>

  <div class="overview-content">
    <ng-container *ngIf="activeTab === 'collectors'; else teamsView">
      <div class="results-heading">
        <div class="results-description">
          <strong>
            {{ response?.count ?? 0 }}
            {{ availabilityFilter === 'all' || availabilityFilter === 'notSubmitted'
              ? 'collectors'
              : 'available collectors' }}
          </strong>
          <span *ngIf="availabilityFilter !== 'availableAtLeastOnce'">
            {{ availabilityFilter === 'all'
              ? 'All collectors matching the filters'
              : availabilityFilter === 'notSubmitted'
                ? 'Availability not submitted for the selected date'
                : 'Free for the entire selected period' }}
          </span>
        </div>
        <div class="results-controls">
          <label class="skill-filter-control">
            <span>Skill</span>
            <select [value]="skill" (change)="onSkillChanged($any($event.target).value)">
              <option value="">All skills</option>
              <option *ngFor="let option of skillOptions" [value]="option.label">{{ option.label }}</option>
            </select>
          </label>
          <label class="sort-control">
            <span>Sort by</span>
            <select [value]="sort" (change)="onSortChanged($any($event.target).value)">
              <option value="name">Name (A–Z)</option>
              <option value="score">Score (high–low)</option>
            </select>
          </label>
        </div>
      </div>
      <app-collector-availability-list
        [rows]="response?.rows ?? []"
        [count]="response?.count ?? 0"
        [unavailableCount]="response?.unavailableCount ?? 0"
        [pageIndex]="page"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [selectedFromMinute]="fromMinute"
        [selectedToMinute]="toMinute"
        [availabilityFilter]="availabilityFilter"
        [clearPinnedTick]="clearPinnedTick"
        [loading]="loading"
        [error]="error"
        (pageChange)="onPageChanged($event)"
        (pinnedChange)="onPinnedChange($event)"
      ></app-collector-availability-list>
    </ng-container>
    <ng-template #teamsView>
      <app-team-availability-list
        [teams]="teams"
        [selectedFromMinute]="fromMinute"
        [selectedToMinute]="toMinute"
        (teamSelected)="drillIntoTeam($event)"
      ></app-team-availability-list>
    </ng-template>
  </div>
</section>
